import OptionsHelper from '@/utils/OptionsHelper';
import { DatePeriodFormControlName, DatePeriodMode } from '../enums';

export const DEFAULT_DATE_PERIOD = '1 year';
const DATE_PERIOD_SHORTEST_VALUES = [
  '1 month',
  '3 months',
  '6 months',
  DEFAULT_DATE_PERIOD,
  '2 years',
];
const DATE_PERIOD_SHORTEN_VALUES = [
  ...DATE_PERIOD_SHORTEST_VALUES,
  '3 years',
  '5 years',
];
const DATE_PERIOD_FULL_VALUES = [
  ...DATE_PERIOD_SHORTEN_VALUES,
  '10 years',
  '10+ years',
];

export const DATE_PERIOD_SHORTEST_OPTIONS = OptionsHelper
  .mapValuesIntoOptions(DATE_PERIOD_SHORTEST_VALUES);

export const DATE_PERIOD_SHORTEN_OPTIONS = OptionsHelper
  .mapValuesIntoOptions(DATE_PERIOD_SHORTEN_VALUES);

export const DATE_PERIOD_FULL_OPTIONS = OptionsHelper
  .mapValuesIntoOptions(DATE_PERIOD_FULL_VALUES);

export const DATE_PERIOD_OPTIONS_BY_MODE = {
  [DatePeriodMode.Full]: DATE_PERIOD_FULL_OPTIONS,
  [DatePeriodMode.Shorten]: DATE_PERIOD_SHORTEN_OPTIONS,
  [DatePeriodMode.Shortest]: DATE_PERIOD_SHORTEST_OPTIONS,
};

export const DATE_PERIOD_DEFAULT_VALUES = {
  [DatePeriodFormControlName.DatePeriod]: '',
};
